(function(Dropzone) {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputFileDropzone', cpInputFileDropzone);

    cpInputFileDropzone.$inject = ['$filter', 'checkModelPermissionsSrvc'];

    function cpInputFileDropzone($filter, checkModelPermissionsSrvc) {
        var thumbnailWidth = 120,
            thumbnailHeight = 120;

        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-file-dropzone/input-file-dropzone.html',
            scope: {
                title: '@',
                object: '=',
                objectType: '@',
                prop: '@',
                propPk: '@',
                modelPermissions: '=?',
                onCreate: '&',
                onDelete: '&',
                defaultMessage: '@'
            },
            link: function(scope, element, attrs, controller) {
                scope.hasViewPermissions = hasViewPermissions;
                scope.hasAddPermissions = hasAddPermissions;
                scope.hasDeletePermissions = hasDeletePermissions;

                function hasViewPermissions() {
                    return scope.modelPermissions && !checkModelPermissionsSrvc.isDenied(
                        scope.modelPermissions.view);
                }

                function hasAddPermissions() {
                    return scope.modelPermissions && !checkModelPermissionsSrvc.isDenied(
                        scope.modelPermissions.add);
                }

                function hasDeletePermissions() {
                    return scope.modelPermissions && !checkModelPermissionsSrvc.isDenied(
                        scope.modelPermissions.delete);
                }

                scope.$watch('object', function(newValue, oldValue) {
                    if (scope.object && scope.object[scope.prop]) {
                        new Dropzone(element.find('#dropzone')[0], {
                            url: '/',
                            clickable: scope.hasAddPermissions()? true : false,
                            acceptedFiles: 'image/*',
                            autoProcessQueue: false,
                            previewTemplate: element.find('#preview-template')[0].innerHTML,
                            dictDefaultMessage: scope.defaultMessage,
                            init: function() {
                                var self = this;

                                scope.object[scope.prop].map(function(item) {
                                    var imgUrl = $filter('cpImageRender')
                                            (item, thumbnailWidth, thumbnailHeight, scope.objectType);

                                    self.files.push(item);
                                    self.options.addedfile.call(self, item);
                                    self.options.thumbnail.call(self, item, imgUrl);
                                    self.createThumbnailFromUrl(item, imgUrl, function() {
                                        self.options.complete.call(self, item);
                                    }, 'anonymous');
                                });

                                this.on("addedfile", function(file) {
                                    scope.onCreate({
                                        file: file,
                                        successCallback: function(filePk) {
                                            file[scope.propPk] = filePk;
                                        }
                                    });
                                });

                                this.on("removedfile", function(file) {
                                    scope.onDelete({pk: file[scope.propPk]});
                                });
                            }
                        });
                    }
                });
            }
        };
    }
})(window.Dropzone);
